import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";

import {
  makeStyles,
  Grid,
  Box,
  Dialog,
  DialogContent,
  FormControlLabel,
  FormControl,
  TextField,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { Select } from "antd";
import AdjustmentReviewInfoIcon from "../../../images/Infoicon.svg";
import TableHeaderInfoIcon from "../../../images/Info.svg";
import {
  formatDateBySetting,
  formatBackToDateFromSetting,
  convertValuesFMPipeline,
  convertValuesPipeline,
  getResponse,
  converDateFormatForPicker,
} from "../../../shared-resources/utils";
import { transitionTimeValues } from "../../../shared-resources/dumpData";
import CustomDatePicker from "../../../common-components/CustomDatePicker";
import {
  updateOpportunityLeadSpreadAPI,
  getOpportunityGraphAPI,
  updateOpportunitySpreadRevenueAPI,
  updateOpportunitySpreadTypeAPI,
  updateOpportunityTransitionSpreadAPI,
} from "../../../api/financial-management-api";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const useStyles = makeStyles((theme) => ({
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },

  selectedLabel: {
    color: "#0070D2",
  },
  addDialog: {
    width: "1270px",
    height: "auto",
    position: "relative",
  },

  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  viewRatePopupBtn: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },

  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
    cursor: "pointer",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },
  bodyScroll: {
    overflowX: "auto",
    maxHeight: 500,
  },

  table: {
    width: "100%",
    marginTop: "1px",
    backgroundColor: "#e6eaeb", // Milky white background for the table
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: "auto",
  },
  tableHeader: {
    backgroundColor: "#01539a",
    color: "white",
    fontWeight: "bold",
  },
  zebraRow: {
    backgroundColor: "#f5f5f5",
  },
  zebraRowDark: {
    backgroundColor: "#fff",
  },
  closeSection: {
    position: "absolute",
    cursor: "pointer",
    right: theme.spacing(0.25),
    top: theme.spacing(0.25),
  },
  closeIcon: {
    color: "#C4C4C4",
  },
  metaData: {
    width: "85%",
    fontWeight: 500,
    fontSize: "13px",
    textAlign: "left",
    alignContent: "center",
    background: "#F3F3F3",
    borderRight: "1px solid #6e6d6d",
    paddingLeft: "8px",
  },
  centerAlignedHeaderLeftBorder: {
    borderLeft: "1px solid #fff !important",
    textAlign: "center",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  disabled: {
    pointerEvents: "none", // prevents clicking
    opacity: 0.5, // visually indicate disabled
    cursor: "not-allowed",
  },
}));

const PipelineOpportunity = ({
  showOpportunities,
  onCloseOpportunities,
  graphData,
  isSalesForce,
  loadOppListForLatestFin,
}) => {
  const classes = useStyles();

  const [data, setData] = useState();

  const [initialData, setInitialData] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const [isEditablePer, setIsEditablePer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditTran, setIsEditTran] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [dateFormat, setDateFormat] = useState("DD/MM/YYYY");
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [revErrMsg, setRevErrMsg] = useState(false);
  const [phaseErrMsg, setPhaseErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [revText, setRevText] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [spreadType, setSpreadType] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [percentageData, setPercentageData] = useState([]);

  const handleChangeSpreadType = (e) => {
    if (!isEditablePer) {
      setMsgType("error");
      setMsgText("Please click Edit before changing the spread type.");
      setEmptyErrMsg(true);
      return;
    }

    setConfirmOpen(true);
  };

  const resetData = (data) => {
    const changedData = JSON.parse(JSON.stringify(data));

    if (
      !changedData.headerList.length &&
      !changedData.transitionSpread.length &&
      !changedData.revenueSpread.length
    ) {
      setData(changedData);
      setInitialData(changedData);
      setLoading(false);
      setIsEdit(false);
      setIsEditTran(false);
      setIsEditable(false);
      setIsEditablePer(false);
      setConfirmOpen(false);
      return;
    }

    const perData = [];

    changedData.headerList.forEach((item) => {
      item.year = new Date(item.monthDate).getFullYear();
    });

    changedData.transitionSpread.forEach((item) => {
      item.year = new Date(item.monthDate).getFullYear();
    });

    changedData.revenueSpread.forEach((item) => {
      const year = new Date(item.monthDate).getFullYear();
      if (!perData.some((val) => val.year === year)) {
        perData.push({ year: year, data: [item] });
      } else {
        perData.forEach((val) => {
          if (val.year === year) {
            val.data.push(item);
          }
        });
      }
      item.year = year;
    });

    setPercentageData(perData);

    const allYears = [
      ...changedData.transitionSpread.map((item) => item.year),
      ...changedData.revenueSpread.map((item) => item.year),
    ];
    const startYear = Math.min(...allYears);
    const endYear = Math.max(...allYears);

    setSelectedYear(startYear);

    changedData.minYear = startYear;
    changedData.maxYear = endYear;

    setData(changedData);
    setInitialData(changedData);
    setLoading(false);
    setIsEdit(false);
    setIsEditTran(false);
    setIsEditable(false);
    setIsEditablePer(false);
    setConfirmOpen(false);
  };

  const handleYearChange = (direction) => {
    if (!data.minYear || !data.maxYear) return;

    if (direction === "increment") {
      if (selectedYear < data.maxYear) {
        setSelectedYear((prevYear) => prevYear + 1);
      }
    } else {
      if (selectedYear > data.minYear) {
        setSelectedYear((prevYear) => prevYear - 1);
      }
    }
  };

  const okConfirmClick = (val) => {
    if (val) {
      setLoading(true);
      updateOpportunitySpreadTypeAPI(
        data.oppNo,
        spreadType === "Manual" ? "Standard" : "Manual",
      ).then((res) => {
        if (res.status === 200) {
          setSpreadType(spreadType === "Manual" ? "Standard" : "Manual");

          getOpportunityGraphAPI(data.oppNo).then((response) => {
            if (response.status === 200) {
              resetData(response.data);
            }
          });
        }
        if (res.status === 400) {
          setLoading(false);
          setMsgType("error");
          setMsgText(res.message);
          setEmptyErrMsg(true);
        }
      });
    }
  };

  const cancelConfirmClick = (val) => {
    if (val) {
      setConfirmOpen(false);
    }
  };

  const handleEditPercentageClick = () => {
    setIsEditablePer(true);
    const resetData = JSON.parse(JSON.stringify(data));
    resetData.revenueSpread = [...initialData.revenueSpread];
    setData(resetData);
    setIsEdit(false);
    setIsEditable(false);
  };

  // const handleSavePercentageClick = () => {
  //   if (calculatePercentageTotal() !== 100) {
  //     setRevText("Total percentage must be equal to 100%");
  //     setMsgType("error");
  //     setRevErrMsg(true);
  //     return;
  //   }
  //   handleTableSaveClick("Percent");
  // };
  const handleSavePercentageClick = () => {
    if (calculatePercentageTotal() !== 100) {
      setRevText("*Please make sure that the total sum is 100%");
      setMsgType("error");
      setRevErrMsg(true);

      setTimeout(() => {
        setRevErrMsg(false);
        setRevText("");
        setMsgType("");
      }, 6000);

      return;
    }

    setRevErrMsg(false);
    handleTableSaveClick("Percent");
  };

  const handleCancelPercentageClick = () => {
    const resetData = JSON.parse(JSON.stringify(data));
    resetData.revenueSpread = [...initialData.revenueSpread];
    setData(resetData);
    setIsEditablePer(false);
  };

  useEffect(() => {
    if (graphData) {
      const changedData = JSON.parse(JSON.stringify(graphData));
      if (isSalesForce && changedData.spreadType === "Equal") {
        changedData.spreadType = "Standard";
      }
      setSpreadType(changedData.spreadType);
      resetData(changedData);
    }
  }, [graphData]);

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData,
  );

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0) {
      setDateFormat(
        converDateFormatForPicker(
          getResponse(generalSettingsData, [])[0].date_format,
        ),
      );
    }
  }, [generalSettingsData]);
  const getDate = (date) => {
    if (date && date !== "") {
      const dateVal = new Date(date);
      return dateVal;
    }
    return null;
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  // const handleYearChange = (direction) => {
  //   if (direction === "increment") {
  //     if (
  //       selectedYear !== data.revenueSpread[data.revenueSpread.length - 1].year
  //     ) {
  //       setSelectedYear((prevYear) => prevYear + 1);
  //     }
  //   } else {
  //     if (selectedYear !== data.revenueSpread[0].year) {
  //       setSelectedYear((prevYear) => prevYear - 1);
  //     }
  //   }
  // };

  const handleEditClick = () => {
    setIsEditable(true);
    setIsEdit(false);
    setIsEditablePer(false);
  };

  const handleChange = (e, key) => {
    const changedData = JSON.parse(JSON.stringify(data));
    changedData[key] = e;
    setData(changedData);
  };

  const handleSpreadClick = () => {
    setLoading(true);
    setEmptyErrMsg(false);
    updateOpportunityLeadSpreadAPI(
      data.oppNo,
      data.transitionPeriod,
      data.spreadDuration,
    ).then((res) => {
      if (res.status === 200) {
        setIsEditable(false);
        setLoading(false);
        loadOppListForLatestFin(true);
        getOpportunityGraphAPI(data.oppNo).then((response) => {
          if (response.status === 200) {
            resetData(response.data);
          }
        });
        setMsgType("success");
        setMsgText("Data updated successfully.");
        setEmptyErrMsg(true);
      } else if (res.status === 400) {
        setLoading(false);
        setMsgType("error");
        setMsgText(res.message);
        setEmptyErrMsg(true);
      }
    });
    // setFormData(tempData);
    // const updatedRowData = JSON.parse(JSON.stringify(data));
    // const year = new Date().getFullYear();
    // const duration = formData.duration ? parseInt(formData.duration) : 0;
    // const leadTime = formData.leadTime ? parseInt(formData.leadTime) : 0;
    // const dataBind = [];
    // const total = duration + leadTime;
    // for (let i = 0; i < total; i++) {
    //   const monthName = new Date(0, i).toLocaleString("default", {
    //     month: "short",
    //   });
    //   dataBind.push({
    //     value:
    //       i < leadTime
    //         ? 0
    //         : Math.round(
    //             (parseInt(data[0].totalYearRevenue) / duration) * 100
    //           ) / 100,
    //     month: monthName,
    //     year: year + Math.floor(i / 12),
    //   });
    //   if (i === leadTime) {
    //     const date = new Date(new Date().getFullYear(), 0, 1);
    //     date.setMonth(date.getMonth() + i);
    //     updatedRowData[0].deliveryStartDate = formatDateBySetting(
    //       date,
    //       "YYYY-MM-DD"
    //     );
    //   }
    //   if (i === total - 1) {
    //     const date = new Date(new Date().getFullYear(), 0, 1);
    //     date.setMonth(date.getMonth() + i + 1);
    //     date.setDate(date.getDate() - 1);
    //     updatedRowData[0].deliveryEndDate = formatDateBySetting(
    //       date,
    //       "YYYY-MM-DD"
    //     );
    //   }
    // }
    // updatedRowData[0].monthlyData = dataBind;
    // setData(updatedRowData);
  };

  const handleCancelClick = () => {
    setIsEditable(false);
    setData(initialData);
  };

  const handleTableEditClick = () => {
    setIsEdit(true);
    const resetData = JSON.parse(JSON.stringify(data));
    resetData.revenueSpread = [...initialData.revenueSpread];
    setData(resetData);
    setIsEditablePer(false);
    setIsEditable(false);

    // setEditingRowId(id);
    // const rowToEdit = data.find((row) => row.id === id);
    // setEditedRowData({ ...rowToEdit });
  };

  const handleTableEditTranClick = () => {
    setIsEditTran(true);
  };

  const handleTableSaveTranClick = () => {
    setLoading(true);
    const updatedData = JSON.parse(JSON.stringify(data));
    updatedData.revenueSpread.forEach((item) => {
      if (item.year) delete item.year;
    });
    updateOpportunityTransitionSpreadAPI(updatedData).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setIsEdit(false);
        getOpportunityGraphAPI(data.oppNo).then((response) => {
          if (response.status === 200) {
            resetData(response.data);
          }
        });
        setMsgType("success");
        setMsgText("Data updated successfully.");
        setEmptyErrMsg(true);
      } else if (res.status === 400) {
        setLoading(false);
        setMsgType("error");
        setMsgText(res.message);
        setEmptyErrMsg(true);
      }
    });
  };

  const handleTableCancelTranClick = () => {
    setIsEditTran(false);
    const resetData = JSON.parse(JSON.stringify(data));
    resetData.transitionSpread = [...initialData.transitionSpread];
    setData(resetData);
  };

  const handleTableInputChangeMonth = (field, value) => {
    const updatedRowData = JSON.parse(JSON.stringify(data));
    updatedRowData.revenueSpread.forEach((item) => {
      if (item.monthDate === field.monthDate) {
        item.data = Number(value);
      }
    });
    updatedRowData.isRevenueUpdated = true;
    setData(updatedRowData);
  };

  const handleTableInputChangeMonthTrans = (field, value) => {
    const updatedRowData = JSON.parse(JSON.stringify(data));
    updatedRowData.transitionSpread.forEach((item) => {
      if (item.monthDate === field.monthDate) {
        item.data = Number(value);
      }
    });
    updatedRowData.isTransitionUpdated = true;
    setData(updatedRowData);
  };

  const handleTableInputChangePercentage = (field, value) => {
    const updatedRowData = JSON.parse(JSON.stringify(data));
    updatedRowData.revenueSpread.forEach((item) => {
      if (item.monthDate === field.monthDate) {
        item.pct = Number(value);
      }
    });
    updatedRowData.isRevenueUpdated = true;
    setData(updatedRowData);
  };

  const handleTableSaveClick = (type) => {
    setLoading(true);
    const updatedData = JSON.parse(JSON.stringify(data));
    delete updatedData.minYear;
    delete updatedData.maxYear;
    updatedData.revenueSpread.forEach((item) => {
      if (item.year) delete item.year;
    });
    updatedData.transitionSpread.forEach((item) => {
      if (item.year) delete item.year;
    });
    updatedData.headerList.forEach((item) => {
      if (item.year) delete item.year;
    });
    updatedData.dataTypeUpdated = type;

    updateOpportunitySpreadRevenueAPI(updatedData).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setIsEdit(false);
        loadOppListForLatestFin(true);
        getOpportunityGraphAPI(data.oppNo).then((response) => {
          if (response.status === 200) {
            resetData(response.data);
          }
        });
        setMsgType("success");
        setMsgText("Data updated successfully.");
        setEmptyErrMsg(true);
      } else if (res.status === 400) {
        setLoading(false);
        setRevText(res.message); // catch res.message here
        setMsgType("error");
        setPhaseErrMsg(true);

        // Auto-hide after 6 seconds
        setTimeout(() => {
          setPhaseErrMsg(false);
          setRevText("");
          setMsgType("");
        }, 6000);

        return;
      }
    });
  };

  const handleTableCancelClick = () => {
    setIsEdit(false);
    // const resetData = JSON.parse(JSON.stringify(data));
    // resetData.revenueSpread = [...initialData.revenueSpread];
    // resetData.transitionPeriod = [...initialData.transitionPeriod];
    // resetData.isRevenueUpdated = false;
    // resetData.isTransitionUpdated = false;
    setData(initialData);
  };

  const currencyList = [
    { label: "USD", value: "USD" },
    { label: "AED", value: "AED" },
    { label: "ARS", value: "ARS" },
    { label: "AUD", value: "AUD" },
    { label: "BRL", value: "BRL" },
  ];

  const headings = [
    "Type",
    "Start Date",
    "End Date",
    "Total Amount",
    "CY Amount",
  ];

  const headingsTransition = [
    "Transition Start Date",
    "Transition End Date",
    "Transition Cost",
  ];

  const onChangeCurrency = (val) => {
    setSelectedCurrency(val);
  };

  const revenueSpreadForSelectedYear = () => {
    let revenue = 0;
    if (data.revenueSpread)
      data.revenueSpread.forEach((item) => {
        if (item.year === selectedYear) {
          revenue += item.data;
        }
      });
    return revenue;
  };
  const totalSpreadForSelectedYear = () => {
    const rev =
      data.revenueSpread
        ?.filter((item) => item.year === selectedYear)
        .reduce((sum, item) => sum + item.data, 0) || 0;

    const trans =
      data.transitionSpread
        ?.filter((item) => item.year === selectedYear)
        .reduce((sum, item) => sum + item.data, 0) || 0;

    return rev + trans;
  };

  const transitionSpreadForSelectedYear = () => {
    let revenue = 0;
    if (data.transitionSpread)
      data.transitionSpread.forEach((item) => {
        if (item.year === selectedYear) revenue += item.data;
      });
    return revenue;
  };

  const revenueSpreadTotal = () => {
    let revenue = 0;
    if (data.revenueSpread)
      data.revenueSpread.forEach((item) => {
        revenue += item.data;
      });
    return revenue;
  };

  const transitionSpreadTotal = () => {
    let revenue = 0;
    if (data.transitionSpread)
      data.transitionSpread.forEach((item) => {
        revenue += item.data;
      });
    return revenue;
  };

  const calculatePercentageTotal = () => {
    let revenue = 0;
    if (data.revenueSpread)
      data.revenueSpread.forEach((item) => {
        revenue += item.pct;
      });
    return Math.round(Number(revenue) * 100) / 100;
  };

  const calculateMonthlyTotal = (monthDate) => {
    let total = 0;
    if (data.revenueSpread)
      data.revenueSpread.forEach((item) => {
        if (item.monthDate === monthDate) {
          total += item.data;
        }
      });
    if (data.transitionSpread)
      data.transitionSpread.forEach((item) => {
        if (item.monthDate === monthDate) total += item.data;
      });
    return total;
  };

  return (
    <>
      {data && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showOpportunities}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => {
                  setIsEdit(false);
                  setIsEditable(false);
                  setIsEditTran(false);
                  setIsEditablePer(false);
                  onCloseOpportunities();
                }}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>{data?.oppName}</div>
            </div>
            <div>
              <Grid container spacing={2} style={{ marginTop: "16px" }}>
                <Grid item lg={2}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    Close Date
                  </label>
                  <input
                    type="text"
                    name="duration"
                    value={formatDateBySetting(
                      new Date(data.closedDate.replace(/-/g, "/")),
                      dateFormat,
                    )}
                    disabled
                    style={{
                      height: "25px",
                      padding: "4px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      background: "#F3F3F3",
                    }}
                  />
                </Grid>
                <Grid item lg={3}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    Transition Period (in Days)
                  </label>

                  {isEditable ? (
                    <Select
                      showSearch
                      mode="single"
                      size="small"
                      className="filterAntSelect"
                      style={{ width: "100%", zIndex: 9 }}
                      placeholder=""
                      showArrow
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label.toString().toLowerCase() ?? "").includes(
                          input.toString().toLowerCase(),
                        )
                      }
                      options={transitionTimeValues}
                      value={data.transitionPeriod}
                      onChange={(val) => handleChange(val, "transitionPeriod")}
                    />
                  ) : (
                    <input
                      type="text"
                      value={
                        transitionTimeValues.find(
                          (opt) => opt.value === data.transitionPeriod,
                        )?.label || ""
                      }
                      disabled
                      style={{
                        height: "25px",
                        padding: "4px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        width: "100%",
                        background: "#F3F3F3",
                      }}
                    />
                  )}
                </Grid>

                <Grid item lg={3}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontWeight: "bold",
                    }}
                  >
                    Duration of Spread(in Months)
                  </label>
                  <input
                    type="number"
                    name="duration"
                    value={
                      isEditable
                        ? data?.spreadDuration || 0
                        : data.spreadDuration
                    }
                    disabled={!isEditable}
                    onChange={(e) =>
                      handleChange(e.target.value, "spreadDuration")
                    }
                    style={{
                      height: "25px",
                      padding: "4px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      background: isEditable ? "#FFFFFF" : "#F3F3F3",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginTop: "25px",
                  }}
                >
                  {isEditable ? (
                    <div style={{ marginBottom: "23px" }}>
                      <span
                        className={classes.saveBtn}
                        onClick={handleSpreadClick}
                      >
                        <span className={classes.editText}>Save</span>
                      </span>
                      <span
                        className={classes.cancelBtn}
                        onClick={handleCancelClick}
                      >
                        <span className={classes.editText}>Cancel</span>
                      </span>
                    </div>
                  ) : (
                    <>
                      {!isSalesForce &&
                        localStorage.getItem("accessType") === "RW" && (
                          <span
                            className={`${classes.editBtn} ${
                              isEditablePer || isEdit ? classes.disabled : ""
                            }`}
                            onClick={
                              isEditablePer || isEdit
                                ? undefined
                                : handleEditClick
                            }
                          >
                            <EditIcon className={classes.editIcon} />
                            <span className={classes.editText}>Edit</span>
                          </span>
                        )}
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: "8px" }}>
                <Grid item lg={8}>
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    Opportunity Information
                  </span>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: "2px" }}>
                <Grid item lg={8}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    style={{
                      border: "1px solid #F3F3F3",
                      borderRadius: "5px",
                      height: "28px",
                    }}
                  >
                    <Box className={classes.metaData}>
                      <div>Stage: {data?.stage}</div>
                    </Box>
                    <Box
                      style={{
                        width: "100%",
                        fontWeight: 500,
                        fontSize: "13px",
                        textAlign: "left",
                        alignContent: "center",
                        background: "#F3F3F3",
                        paddingLeft: "8px",
                      }}
                    >
                      <div>Forecast Category: {data?.forecastCategory}</div>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {percentageData.length > 0 &&
                data.revenueSpread &&
                data.revenueSpread.length > 0 && (
                  <Grid
                    container
                    spacing={1}
                    style={{ marginTop: "15px", alignItems: "center" }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        Revenue Distribution for Adjusted Revenue
                        (CompanyValue-TransitionCost)
                      </span>

                      {isEditablePer ? (
                        <div style={{ display: "flex", gap: "2px" }}>
                          <span
                            className={classes.saveBtn}
                            onClick={() => handleSavePercentageClick()}
                          >
                            <span className={classes.editText}>Save</span>
                          </span>
                          <span
                            className={classes.cancelBtn}
                            onClick={handleCancelPercentageClick}
                          >
                            <span className={classes.editText}>Cancel</span>
                          </span>
                        </div>
                      ) : (
                        !isSalesForce &&
                        localStorage.getItem("accessType") === "RW" && (
                          <span
                            onClick={
                              isEdit || isEditable
                                ? undefined
                                : handleEditPercentageClick
                            }
                            className={`${classes.editBtn} ${
                              isEdit || isEditable ? classes.disabled : ""
                            }`}
                          >
                            <EditIcon className={classes.editIcon} />
                            <span className={classes.editText}>Edit</span>
                          </span>
                        )
                      )}
                    </Grid>

                    <Grid
                      item
                      lg={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <FormControl
                        component="fieldset"
                        className="financialRadio"
                        style={{ margin: "2px 0px 10px 4px" }}
                      >
                        <RadioGroup
                          aria-label="sectionItem"
                          name="sectionItem"
                          value={spreadType}
                          onChange={(e) => {
                            if (
                              !isSalesForce &&
                              localStorage.getItem("accessType") === "RW"
                            ) {
                              handleChangeSpreadType(e);
                            }
                          }}
                          row
                        >
                          <FormControlLabel
                            className={
                              spreadType === "Standard" && classes.selectedLabel
                            }
                            value="Standard"
                            control={<Radio color="primary" />}
                            label="Standard"
                          />
                          <FormControlLabel
                            className={
                              spreadType === "Manual" && classes.selectedLabel
                            }
                            value="Manual"
                            control={<Radio color="primary" />}
                            label="Manual"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item lg={12}>
                      <table
                        className="pipelineOppsTable"
                        cellPadding={0}
                        cellSpacing={0}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: 600,
                              }}
                            >
                              Total
                            </th>
                            <th>Year</th>
                            {monthNames.map((month) => (
                              <th>{month}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {percentageData.map((yearData, i) => {
                            const monthsForYear = data.revenueSpread.filter(
                              (item) => item.year === yearData.year,
                            );

                            return (
                              <tr key={yearData.year}>
                                {i === 0 && (
                                  <td
                                    rowSpan={percentageData.length}
                                    style={{
                                      textAlign: "center",
                                      background: "#dce5e6",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {calculatePercentageTotal()}%
                                  </td>
                                )}

                                <td>{yearData.year}</td>

                                {/* Render months */}
                                {Array.from({ length: 12 }).map(
                                  (_, monthIndex) => {
                                    const monthObj = monthsForYear.find(
                                      (m) =>
                                        new Date(m.monthDate).getMonth() ===
                                        monthIndex,
                                    );
                                    return (
                                      <td key={monthIndex}>
                                        {monthObj ? (
                                          isEditablePer &&
                                          spreadType === "Manual" ? (
                                            <input
                                              type="number"
                                              style={{ width: "60px" }}
                                              value={monthObj.pct}
                                              onChange={(e) =>
                                                handleTableInputChangePercentage(
                                                  monthObj,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          ) : (
                                            monthObj.pct
                                          )
                                        ) : (
                                          "" // empty cell
                                        )}
                                      </td>
                                    );
                                  },
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {revErrMsg && (
                        <div style={{ textAlign: "right" }}>
                          <FormHelperText
                            error={msgType === "error"}
                            style={{
                              border: "2px solid #FF3131",
                              backgroundColor: "#FFCFCF",
                              color: "black",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              display: "inline-block",
                              marginTop: "8px",
                            }}
                          >
                            {revText}
                          </FormHelperText>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                )}

              <Grid
                container
                spacing={2}
                style={{ marginTop: "25px", alignItems: "center" }}
              >
                <Grid
                  item
                  lg={8}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    Workbench-Revenue Phasing (Numbers)
                  </span>

                  <td rowSpan={3}>
                    {isEdit ? (
                      <>
                        <span
                          className={classes.saveBtn}
                          onClick={() => handleTableSaveClick("Number")}
                        >
                          <span className={classes.editText}>Save</span>
                        </span>
                        <span
                          className={classes.cancelBtn}
                          onClick={handleTableCancelClick}
                        >
                          <span className={classes.editText}>Cancel</span>
                        </span>
                      </>
                    ) : (
                      !isSalesForce &&
                      localStorage.getItem("accessType") === "RW" && (
                        <div
                          onClick={
                            isEditable || isEditablePer
                              ? undefined
                              : handleTableEditClick
                          }
                          className={`${classes.editBtn} ${
                            isEditable || isEditablePer ? classes.disabled : ""
                          }`}
                        >
                          <EditIcon className={classes.editIcon} />
                          <span className={classes.editText}>Edit</span>
                        </div>
                      )
                    )}
                  </td>
                </Grid>

                <Grid item lg={4} style={{ marginBottom: "15px" }}>
                  <Box display="flex" flexDirection="column">
                    <Box display="flex" justifyContent="flex-end">
                      <Box display="flex" flexDirection="column">
                        {/* <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                          marginBottom: "4px",
                        }}
                      >
                        Currency
                      </div> */}
                        {data.revenueSpread &&
                          data.revenueSpread.length > 0 && (
                            <Box display="flex" alignItems="center">
                              {/* <Select
                          value={selectedCurrency}
                          onChange={onChangeCurrency}
                          options={currencyList}
                          style={{
                            width: 120,
                            marginBottom: "5px",
                          }}
                          placeholder="Select Currency"
                        /> */}

                              <Box display="flex" alignItems="center">
                                <button
                                  onClick={() => handleYearChange("decrement")}
                                  title={
                                    selectedYear !== data.minYear
                                      ? "Previous Year"
                                      : ""
                                  }
                                  style={{
                                    border: "none",
                                    background: "none",
                                    color:
                                      selectedYear === data.minYear
                                        ? "#B2D4E6"
                                        : "#0070D2",
                                    cursor:
                                      selectedYear === data.minYear
                                        ? "default"
                                        : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 0,
                                    marginRight: "2px",
                                  }}
                                >
                                  <NavigateBeforeIcon />
                                </button>

                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: "#0070D2",
                                  }}
                                >
                                  {selectedYear}
                                </div>

                                <button
                                  onClick={() => handleYearChange("increment")}
                                  title={
                                    selectedYear !== data.maxYear
                                      ? "Next Year"
                                      : ""
                                  }
                                  style={{
                                    border: "none",
                                    background: "none",
                                    color:
                                      selectedYear === data.maxYear
                                        ? "#B2D4E6"
                                        : "#0070D2",
                                    cursor:
                                      selectedYear === data.maxYear
                                        ? "default"
                                        : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 0,
                                    marginLeft: "2px",
                                  }}
                                >
                                  <NavigateNextIcon />
                                </button>
                              </Box>
                            </Box>
                          )}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Box>
                <Box
                  style={{
                    overflowX: "auto",
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                >
                  <table
                    className="pipelineOppsTable"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        {headings.map((heading) => (
                          <th key={heading}>
                            {heading === "CY Amount" ||
                            heading === "Total Amount" ? (
                              <>
                                {heading}
                                <img
                                  src={TableHeaderInfoIcon}
                                  alt="Profile"
                                  title={
                                    heading === "CY Amount"
                                      ? "Revenue is displaying for selected year"
                                      : "Total Amount represents the sum of all years transition and adjusted amounts"
                                  }
                                  style={{
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                    width: "12px",
                                    lineHeight: "12px",
                                    borderRadius: "50%",
                                    marginLeft: "3px",
                                    cursor: "default",
                                  }}
                                />
                              </>
                            ) : (
                              heading
                            )}
                          </th>
                        ))}

                        {data.headerList
                          .filter((item) => item.year === selectedYear)
                          .map((heading) => (
                            <th key={heading.displayName}>
                              {heading.displayName}
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {isEdit && spreadType === "Manual" ? (
                          <>
                            <td>Transition Cost</td>
                            <td>{data.transitionStartDate}</td>
                            <td>{data.transitionEndDate}</td>
                            {/* <td>
                            {convertValuesFMPipeline(transitionSpreadTotal())}
                          </td>
                          <td>{convertValuesFMPipeline(0)}</td> */}
                            <td style={{ fontWeight: 600 }}>
                              {" "}
                              {convertValuesPipeline(data.transitionTotal)}
                            </td>
                            <td>
                              {convertValuesFMPipeline(
                                transitionSpreadForSelectedYear(),
                              )}
                            </td>
                            {data.headerList
                              .filter((item) => item.year === selectedYear)
                              .map((month, i) => (
                                <td>
                                  {data.transitionSpread.filter(
                                    (val) => val.monthDate === month.monthDate,
                                  ).length === 0 ? (
                                    convertValuesFMPipeline(0)
                                  ) : (
                                    <input
                                      type="number"
                                      value={
                                        data.transitionSpread.filter(
                                          (val) =>
                                            val.monthDate === month.monthDate,
                                        )[0].data
                                      }
                                      onChange={(e) =>
                                        handleTableInputChangeMonthTrans(
                                          month,
                                          e.target.value,
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              ))}
                          </>
                        ) : (
                          <>
                            <td>Transition Cost</td>
                            <td>{data.transitionStartDate}</td>
                            <td>{data.transitionEndDate}</td>
                            {/* <td>
                            {convertValuesFMPipeline(transitionSpreadTotal())}
                          </td>
                          <td>{convertValuesFMPipeline(0)}</td> */}
                            <td style={{ fontWeight: 600 }}>
                              {" "}
                              {convertValuesPipeline(data.transitionTotal)}
                            </td>
                            <td>
                              {convertValuesFMPipeline(
                                transitionSpreadForSelectedYear(),
                              )}
                            </td>
                            {data.headerList
                              .filter((item) => item.year === selectedYear)
                              .map((month, i) => (
                                <td>
                                  {data.transitionSpread.filter(
                                    (val) => val.monthDate === month.monthDate,
                                  ).length === 0
                                    ? convertValuesFMPipeline(0)
                                    : convertValuesFMPipeline(
                                        data.transitionSpread.filter(
                                          (val) =>
                                            val.monthDate === month.monthDate,
                                        )[0].data,
                                      )}
                                </td>
                              ))}
                          </>
                        )}
                      </tr>
                      <tr>
                        {isEdit ? (
                          <>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {" "}
                              <>
                                Adj.Revenue
                                <img
                                  src={AdjustmentReviewInfoIcon}
                                  alt="Profile"
                                  title="Company Value - Transition Cost"
                                  style={{
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                    width: "12px",
                                    lineHeight: "12px",
                                    borderRadius: "50%",
                                    marginLeft: "3px",
                                    cursor: "default",
                                  }}
                                />
                              </>
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {data.deliveryStartDate}
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {data.deliveryEndDate}
                            </td>
                            {/* <td>
                            {convertValuesFMPipeline(revenueSpreadTotal())}
                          </td>

                          <td>
                            {convertValuesFMPipeline(
                              revenueSpreadForSelectedYear()
                            )}
                          </td> */}
                            <td style={{ fontWeight: 600 }}>
                              {convertValuesPipeline(data.companyValueTotal)}
                            </td>

                            <td>
                              {convertValuesFMPipeline(
                                revenueSpreadForSelectedYear(),
                              )}
                            </td>
                            {data.headerList
                              .filter((item) => item.year === selectedYear)
                              .map((month, i) => (
                                <td>
                                  {data.revenueSpread.filter(
                                    (val) => val.monthDate === month.monthDate,
                                  ).length === 0 ? (
                                    convertValuesFMPipeline(0)
                                  ) : (
                                    <input
                                      type="number"
                                      value={
                                        data.revenueSpread.filter(
                                          (val) =>
                                            val.monthDate === month.monthDate,
                                        )[0].data
                                      }
                                      onChange={(e) =>
                                        handleTableInputChangeMonth(
                                          month,
                                          e.target.value,
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              ))}
                          </>
                        ) : (
                          <>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                verticalAlign: "middle",
                              }}
                            >
                              <>
                                Adj.Revenue
                                <img
                                  src={AdjustmentReviewInfoIcon}
                                  alt="Profile"
                                  title="Company Value - Transition Cost"
                                  style={{
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                    width: "12px",
                                    lineHeight: "12px",
                                    borderRadius: "50%",
                                    marginLeft: "3px",
                                    cursor: "default",
                                  }}
                                />
                              </>
                            </td>

                            <td style={{ whiteSpace: "nowrap" }}>
                              {data.deliveryStartDate}
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {data.deliveryEndDate}
                            </td>
                            {/* <td>
                            {convertValuesFMPipeline(revenueSpreadTotal())}
                          </td>

                          <td>
                            {convertValuesFMPipeline(
                              revenueSpreadForSelectedYear()
                            )}
                          </td> */}
                            <td style={{ fontWeight: 600 }}>
                              {convertValuesPipeline(data.companyValueTotal)}
                            </td>

                            <td>
                              {convertValuesFMPipeline(
                                revenueSpreadForSelectedYear(),
                              )}
                            </td>
                            {data.headerList
                              .filter((item) => item.year === selectedYear)
                              .map((month, i) => (
                                <td>
                                  {data.revenueSpread.filter(
                                    (val) => val.monthDate === month.monthDate,
                                  ).length === 0
                                    ? convertValuesFMPipeline(0)
                                    : convertValuesFMPipeline(
                                        data.revenueSpread.filter(
                                          (val) =>
                                            val.monthDate === month.monthDate,
                                        )[0].data,
                                      )}
                                </td>
                              ))}
                          </>
                        )}
                      </tr>
                      <tr style={{ fontWeight: 600 }}>
                        <td>Total</td>
                        <td></td>
                        <td></td>
                        {/* <td>
                        {convertValuesFMPipeline(
                          revenueSpreadTotal() + transitionSpreadTotal()
                        )}
                      </td>
                      <td>
                        {convertValuesFMPipeline(
                          revenueSpreadForSelectedYear()
                        )}
                      </td> */}
                        <td>{convertValuesPipeline(data.totalRevenue)}</td>
                        <td>
                          {convertValuesFMPipeline(
                            totalSpreadForSelectedYear(),
                          )}
                        </td>
                        {data.headerList
                          .filter((item) => item.year === selectedYear)
                          .map((month, i) => (
                            <td>
                              {convertValuesFMPipeline(
                                calculateMonthlyTotal(month.monthDate),
                              )}
                            </td>
                          ))}
                      </tr>
                    </tbody>
                  </table>
                </Box>
                {phaseErrMsg && (
                  <div style={{ textAlign: "right" }}>
                    <FormHelperText
                      error={msgType === "error"}
                      style={{
                        border: "2px solid #FF3131",
                        backgroundColor: "#FFCFCF",
                        color: "black",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                        marginTop: "8px",
                      }}
                    >
                      {revText}
                    </FormHelperText>
                  </div>
                )}
              </Box>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
      {confirmOpen && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClick}
          okClick={okConfirmClick}
          confirmText={`Do you want switch to ${
            spreadType === "Manual" ? "Standard" : "Manual"
          }?`}
          closeDialog={() => setConfirmOpen(false)}
          title="Confirm"
          buttonText="Yes"
        />
      )}
    </>
  );
};

export default PipelineOpportunity;
